import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `SpinnerWidget` renders a spinner svg image to show a loading
 * state. The spinner can be light or dark, and rendering is
 * resolution independant.
 *
 * @deprecated
 * @param {number} size - Size of the spinner in px
 * @param {boolean} [dark] - When `true`, render the spinner in dark mode
 * @param {string} [imagePath] - Path to an image to show in the spinner
 * @param {string} [visible] - When `true`, make the spinner visible
 */
export default class OldSpinnerWidget extends Widget {
	constructor({ size, dark = false, imagePath, visible = true } = {}) {
		super(...arguments);

		this._size = size;
		this._dark = dark;
		this._imagePath = imagePath;
		this._visible = visible;
	}

	show() {
		this.asJQuery().find(".spinner").removeClass("hidden");
	}

	hide() {
		this.asJQuery().find(".spinner").addClass("hidden");
	}

	renderContentOn(html) {
		const bounceWidth = Math.max(this._size / 3 - 8, 5);
		const spinner = html.div(
			{
				klass: "spinner",
				"data-test": "spinner",
				style: `width:${this._size}px; height:${
					this._size
				}px; line-height:${this._size - bounceWidth / 2}px;`,
			},
			html.div({
				klass: "bounce1",
				style: `width:${bounceWidth}px;height:${bounceWidth}px`,
			}),
			html.div({
				klass: "bounce2",
				style: `width:${bounceWidth}px;height:${bounceWidth}px`,
			}),
			html.div({
				klass: "bounce3",
				style: `width:${bounceWidth}px;height:${bounceWidth}px`,
			}),
		);

		if (this._dark) {
			spinner.addClass("dark");
		}

		if (!this._visible) {
			spinner.addClass("hidden");
		}
	}
}
